import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { VerticalStack } from '@interxfi/design-system/components/alignment/vertical-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { IceTasksTable } from '../../../../../../../../../../features/vendor/ice/task/ice-tasks-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/task/_task/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingVendorIce,
      label: 'Tasks',
      order: 3,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingVendorIce>,
  head: () => getPageHead('ICE Tasks'),
  component: IceTaskList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <VerticalStack gap={7}>
      <PageTabRail
        actions={
          <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
            {filter}
          </HorizontalStack>
        }
        group={TabbedNavigationGroup.ClearingVendorIce}
      />
    </VerticalStack>
  );
}

function IceTaskList() {
  return (
    <PageLayout>
      <PageLayout.Section>
        <IceTasksTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
